module.exports = __webpack_public_path__ + "img/Wilms.ec63f5a9.jpg";